import { alertController, toastController } from "@ionic/vue";
import { backendUrl } from "./variables.js";
import { settings } from "../plugins/settings.js";
import router from '../router';

async function showToast(message, colorType) {
	const toast = await toastController.create({
		message: message,
		duration: 2000,
		color: colorType ?? "dark",
	});
	document.activeElement?.blur();
	return toast.present();
}

export async function checkUserSession(response, colorType) {
	const message = response?.status === 401 ? "Sessione scaduta" : response.data.error;
	if (response?.status === 401) router.push("/login");
	return showToast(message, colorType);
}

export async function checkUserLogin(response, colorType) {
	const message = response?.status === 401 ? "Utente o password non validi" : response.data.error;
	if (response?.status === 401) router.push("/login");
	return showToast(message, colorType);
}

async function showMsgAlert(title, message, cssClass, timeout = 5000) {
	const alert = await alertController.create({
		header: title,
		message: message,
		cssClass: cssClass,
	});
	setTimeout(() => alert.dismiss(), timeout);
	document.activeElement?.blur();
	await alert.present();
}

export const showMsgInfo = (title, message, timeout = 5000) => showMsgAlert(title, message, "alarm-info", timeout);
export const showMsgWarning = (title, message, timeout = 5000) => showMsgAlert(title, message, "alarm-warning", timeout);

export async function showMsgError(title, message) {
	const alert = await alertController.create({
		header: title,
		message: message,
		cssClass: "alarm-error",
		buttons: [
			{
				text: 'Continua',
				handler: () => {
					alert.dismiss(true);
					return false;
				}
			},
		]
	});
	document.activeElement?.blur();
	await alert.present();
}

export async function insertValue(title, fieldName) {
	let inputValue = null;
	const alert = await alertController.create({
		header: title,
		inputs: [
			{
				name: 'inputData',
				type: 'text',
				value: null,
				placeholder: fieldName,
			},
		],
		buttons: [
			{
				text: 'OK',
				handler: (data) => {
					alert.dismiss(data);
				}
			},
			{
				text: 'Annulla',
				handler: () => {
					alert.dismiss(null);
					return false;
				}
			}
		]
	});
	document.activeElement?.blur();
	await alert.present();
	await alert.onDidDismiss().then((data) => {
		if (data.data && data.data.inputData) inputValue = data.data.inputData;
	});
	return inputValue;
}

export async function confirmYesNo(title, message) {
	let choice;
	const alert = await alertController.create({
		header: title,
		message: message,
		buttons: [
			{
				text: 'SI',
				handler: () => {
					alert.dismiss(true);
					return false;
				}
			},
			{
				text: 'No',
				handler: () => {
					alert.dismiss(false);
					return false;
				}
			}
		]
	});
	document.activeElement?.blur();
	await alert.present();
	await alert.onDidDismiss().then((data) => {
		choice = data.data;
	});
	return choice;
}

export function writeLog(...args) {
	if (settings.global.debug) console.log(...args);
}

export function getUserInfo() {
	if (localStorage.getItem("user")) {
		const myUser = JSON.parse(localStorage.getItem("user"));
		if (myUser.avatar_url) {
			myUser.avatar_url = `${backendUrl}${myUser.avatar_url}`;
		}
		return myUser;
	}
}

export function truncate(text, length, clamp) {
	clamp = clamp || '...';
	const node = document.createElement('div');
	node.innerHTML = text;
	const content = node.textContent;
	return content.length > length ? content.slice(0, length) + clamp : content;
}

export function stripHTML(htmlString) {
	const div = document.createElement('div');
	div.innerHTML = htmlString;
	return div.textContent || div.innerText || "";
}

export function checkAdmin(user, adminLikeRole = settings.global.adminLikeRole) {
	if (!user) return false;
	if (user.admin) return true;
	if (!adminLikeRole) return false;
	return user.roles?.some(role => role.name.toLowerCase() === adminLikeRole.toLowerCase()) ?? false;
}
